// NCB calls flow through the Quest proxy. No secret key is exposed to the browser.
const NCB_CONFIG = {
  conversationId: 'chat-87afbd3b-edd8-4f36-a47d-e47ecceaf8d9',
  proxyBase: 'https://rmvzorxcl35mttidiexhtp5g2m0hpsqo.lambda-url.us-east-2.on.aws',
  instance: '56494_growth_sparrow_booking',
};

function buildProxyUrl(path) {
  const url = new URL(path, NCB_CONFIG.proxyBase);
  url.searchParams.set('Instance', NCB_CONFIG.instance);
  return url.toString();
}

async function ncbRequest(url, options = {}) {
  try {
    const response = await fetch(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    const body = await response.json().catch(() => ({}));

    if (!response.ok) {
      return {
        status: 'error',
        data: null,
        error: body?.message || body?.error || `HTTP ${response.status}`,
        httpStatus: response.status,
      };
    }

    if (
      body &&
      typeof body === 'object' &&
      !Array.isArray(body) &&
      typeof body.status === 'string' &&
      'data' in body
    ) {
      return body;
    }

    return { status: 'success', data: body };
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error?.message || 'Network error',
    };
  }
}

export async function publicDataFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/public-data/${path}`), options);
}

export async function authFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/auth/${path}`), options);
}

export async function dataFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/data/${path}`), options);
}